import React from "react";
import View from "./Home.view";

function Home({
	basename = "/app",
	isEmbedded = false
}) {
	return <View
		basename={basename}
		isEmbedded={isEmbedded} />;
}

export default Home;
